import { render } from "./BaseReport.vue?vue&type=template&id=7e490e13&scoped=true"
import script from "./BaseReport.vue?vue&type=script&lang=js"
export * from "./BaseReport.vue?vue&type=script&lang=js"

import "./BaseReport.vue?vue&type=style&index=0&id=7e490e13&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e490e13"]])

export default __exports__